import axios from './httpConfig.js'
//******************货品管理 -- 货品信息 ******************/
// 货品列表
export function GetProductsList(param) {
	return axios.post('/admin/goods/list', param)
}

// 新增货品
export function AddProducts(param) {
	return axios.post('/admin/goods/add', param)
}

// 禁用货品接口
export function DisabledProducts(param) {
	return axios.post('/admin/goods/disabled', param)
}

// 删除货品
export function DeleteProducts(param) {
	return axios.post('/admin/goods/delete', param)
}

// 修改货品
export function EditProducts(param) {
	return axios.post('/admin/goods/edit', param)
} 


//******************货品管理 -- 货品分类 ******************/
// 分类列表
export function GetTypeList(param) {
	return axios.post('/admin/goods/type/list', param)
}

// 新增分类
export function AddType(param) {
	return axios.post('/admin/goods/type/add', param)
} 

// 删除分类
export function DeleteType(param) {
	return axios.post('/admin/goods/type/delete', param)
}

// 修改分类
export function EditType(param) {
	return axios.post('/admin/goods/type/edit', param)
} 

// 禁用分类
export function DisabledType(param) {
	return axios.post('/admin/goods/type/disabled', param)
}

// 货品分类树
export function GetTypeTreeData(param) {
	return axios.post('/admin/goods/type/tree', param)
}

// 货品分类树懒加载
export function GetTypeTreeLazyData(param) {
	return axios.post('/admin/goods/type/tree/children', param)
}

// 根据ID获取全部父级ID
export function GetTypeParentIds(param) {
	return axios.post('/admin/goods/type/parent_ids/forid', param)
}


//******************货品管理 -- 品牌管理 ******************/
// 品牌列表
export function GetBrandList(param) {
	return axios.post('/admin/goods/brand/list', param)
}

// 新增品牌
export function AddBrand(param) {
	return axios.post('/admin/goods/brand/add', param)
} 

// 删除品牌
export function DeleteBrand(param) {
	return axios.post('/admin/goods/brand/delete', param)
}

// 修改品牌
export function EditBrand(param) {
	return axios.post('/admin/goods/brand/edit', param)
} 

// 禁用品牌
export function DisabledBrand(param) {
	return axios.post('/admin/goods/brand/disabled', param)
}


//******************货品管理 -- 计量单位管理 ******************/
// 计量单位列表
export function GetUnitsList(param) {
	return axios.post('/admin/goods/units/list', param)
}

// 新增计量单位
export function AddUnits(param) {
	return axios.post('/admin/goods/units/add', param)
} 

// 删除计量单位
export function DeleteUnits(param) {
	return axios.post('/admin/goods/units/delete', param)
}

// 修改计量单位
export function EditUnits(param) {
	return axios.post('/admin/goods/units/edit', param)
} 

// 禁用计量单位
export function DisabledUnits(param) {
	return axios.post('/admin/goods/units/disabled', param)
}